var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowTopMiddle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "167px",
    height: "168px",
    viewBox: "0 0 167 168",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pixagri",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Aide-3",
    transform: "translate(-742.000000, -162.000000)",
    stroke: "#9EBE4A",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow11",
    transform: "translate(825.159304, 245.943887) rotate(-47.000000) translate(-825.159304, -245.943887) translate(765.344216, 192.051183)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Line-21",
    strokeLinejoin: "round",
    transform: "translate(4.421267, 53.940391) rotate(-150.000000) translate(-4.421267, -53.940391) ",
    points: "1.1999032 50.6774227 7.4312684 50.7242453 7.64263171 57.2033594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4142862,21.2150628 C23.3114126,34.7824815 40.0012294,60.0534858 57.6136368,71.8878953 C69.3552417,79.7775016 86.7101769,84.6716514 109.678442,86.5703446",
    id: "Line-8",
    transform: "translate(61.046364, 53.892704) scale(1, -1) rotate(-33.000000) translate(-61.046364, -53.892704) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTopMiddle);
export default __webpack_public_path__ + "static/media/arrow_top_middle.c94a76fe.svg";
export { ForwardRef as ReactComponent };